import { z } from "zod";
import { paginated, paginationQuery } from "./common.js";
export const auditAction = z.enum([
    "login",
    "login_failed",
    "study_view",
    "study_content_fetch",
    "permission_change",
    "study_publish",
    "study_unpublish",
]);
export const auditEntry = z.object({
    id: z.uuid(),
    userEmail: z.string().nullable(),
    studyId: z.uuid().nullable(),
    studyTitle: z.string().nullable(),
    action: auditAction,
    detail: z.string().nullable(),
    ip: z.string().nullable(),
    occurredAt: z.string(),
});
export const auditList = paginated(auditEntry);
export const auditListQuery = paginationQuery.extend({
    action: auditAction.optional(),
    userId: z.string().optional(),
    studyId: z.uuid().optional(),
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
    /** Coincidencia parcial, sin distinguir mayúsculas, sobre el correo. */
    user: z.string().trim().max(200).optional(),
    /** Coincidencia parcial sobre lo que muestra la columna Insight: título o detalle. */
    insight: z.string().trim().max(200).optional(),
    ip: z.string().trim().max(64).optional(),
});
export const usageMetrics = z.object({
    activeUsers30d: z.number().int(),
    totalUsers: z.number().int(),
    pendingInvitations: z.number().int(),
    publishedStudies: z.number().int(),
    viewsLast30d: z.number().int(),
    topStudies: z.array(z.object({ studyId: z.uuid(), title: z.string(), views: z.number().int() })),
});
//# sourceMappingURL=audit.js.map